/**
 * User Status Bar - Shows current user status and allows changing it
 */

import React from 'react';
import { Dropdown, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useChatWebSocket } from '../../contexts/ChatWebSocketContext';
import { PresenceIndicator } from './PresenceIndicator';
import { StatusSelector } from './StatusSelector';
import './UserStatusBar.css';

export const UserStatusBar: React.FC = () => {
  const { user } = useAuth();
  const { presence, updateStatus } = useChatWebSocket();
  const userPresence = user ? presence[user.id] : null;
  const currentStatus = userPresence?.status || 'offline';

  if (!user) return null;

  const displayName = `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || 'User';
  const statusText = currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1);

  return (
    <div className="user-status-bar">
      <Dropdown
        dropdownRender={() => <StatusSelector currentStatus={currentStatus} onStatusChange={updateStatus} />}
        trigger={['click']}
        placement="bottomLeft"
      >
        <div className="user-status-trigger">
          <PresenceIndicator status={currentStatus} size="small">
            <Avatar size="small" src={user.avatar_url} icon={<UserOutlined />} />
          </PresenceIndicator>
          <div className="user-status-info">
            <div className="user-status-name">
              {displayName}
            </div>
            <div className="user-status-text">
              {statusText}
            </div>
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

